import * as React from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "@mui/material";

import StepOne from "assets/images/landing/howItWorks/step1.jpg";
import StepTwo from "assets/images/landing/howItWorks/step2.jpg";
import StepThree from "assets/images/landing/howItWorks/step3.jpg";

import { ReactComponent as ListArrowIcon } from "assets/images/icon_list_arrow.svg";

const howItWorks = [
  {
    step: 1,
    image: StepOne,
    imageAlign: "left",
    title: "Крок перший",
    content: (
      <>
        Щоб створити посилання на оплату, зайдіть у свій кабінет, натисніть
        «Створити посилання» та введіть реквізити платежу:
        <Box display="flex" alignItems="center" mt={1.5}>
          <ListArrowIcon />
          <Typography variant="h5" sx={{ ml: 1.5 }}>
            Юридичну назву компанії або ФОП;
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" mt={1.5}>
          <ListArrowIcon />
          <Typography variant="h5" sx={{ ml: 1.5 }}>
            ЄДРПОУ або РНОКПП;
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" mt={1.5} mb={1.5}>
          <ListArrowIcon />
          <Typography variant="h5" sx={{ ml: 1.5 }}>
            IBAN;
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" mt={1.5} mb={1.5}>
          <ListArrowIcon />
          <Typography variant="h5" sx={{ ml: 1.5 }}>
            Необхідну суму;
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" mt={1.5} mb={1.5}>
          <ListArrowIcon />
          <Typography variant="h5" sx={{ ml: 1.5 }}>
            Та призначення платежу.
          </Typography>
        </Box>
      </>
    ),
  },
  {
    step: 2,
    image: StepTwo,
    imageAlign: "right",
    title: "Крок другий",

    content:
      "Скопіюйте згенероване посилання та надішліть його клієнту через зручний для вас месенджер.",
  },
  {
    step: 3,
    image: StepThree,
    imageAlign: "left",
    title: "Крок третій",
    content:
      "Клієнт переходить за посиланням або сканує QR код для оплати, натискає «Оплатити», і в банківському додатку автоматично з’являються всі заповнені реквізити. Залишається лише підтвердити платіж за IBAN!",
  },
];

const HowItWorks: React.FC = () => {
  const isXs = useMediaQuery("(max-width: 600px)");

  return (
    <Box sx={styles.howItWorksBlock} id="how-it-works">
      <Container>
        <Box>
          <Typography variant="h2" sx={{ mb: 2.5 }}>
            Як працює оплата на рахунок IBAN
          </Typography>
          <Typography variant="h5">
            Використовуйте сервіс IBAN oplata, щоб створювати посилання на
            оплату. Для цього не потрібні електронні ключі чи складна
            реєстрація.
          </Typography>
        </Box>
        <Box mt={4}>
          {howItWorks.map((item, index) => (
            <Box key={index} sx={styles.stepWrapper}>
              {(item.imageAlign === "left" || isXs) && (
                <Box sx={styles.imageWrapper}>
                  <img
                    style={{ ...styles.image, ...(isXs && styles.imageSm) }}
                    src={item.image}
                  />
                </Box>
              )}
              <Box
                sx={styles.stepContent}
                pl={!isXs && item.imageAlign === "left" ? { xs: 3, md: 10 } : 0}
                pr={
                  !isXs && item.imageAlign === "right" ? { xs: 3, md: 10 } : 0
                }
              >
                <Box sx={styles.stepHeading}>
                  <Box sx={styles.icon}>
                    <Typography variant="h5" color="grey000">
                      {item.step}
                    </Typography>
                  </Box>
                  <Typography variant="h5" color="blue600">
                    {item.title}
                  </Typography>
                </Box>
                <Typography variant="h5">{item.content}</Typography>
              </Box>
              {item.imageAlign === "right" && !isXs && (
                <Box sx={styles.imageWrapper}>
                  <img style={styles.image} src={item.image} />
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

const styles = {
  howItWorksBlock: {
    backgroundColor: "#F5F8FF",
    paddingTop: { xs: "56px", sm: "120px" },
    paddingBottom: { xs: "56px", sm: "120px" },
    textAlign: "center",
  },
  imageWrapper: {
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    width: { xs: "100%", md: "50%" },
    marginBottom: { xs: "20px", md: "0" },
    borderRadius: "24px",
    border: "solid 8px #E1E8FA",
  },
  image: {
    borderRadius: "16px",
    width: "100%",
  },
  imageSm: {
    width: "120%",
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "40px",
    height: "40px",
    borderRadius: "100px",
    marginRight: "12px",
    backgroundColor: "blue600",
  },
  stepWrapper: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: "center",
    justifyContent: "center",
    textAlign: "left",
    paddingTop: "40px",
  },
  stepContent: {
    width: { xs: "100%", md: "50%" },
  },
  stepHeading: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    marginBottom: "20px",
  },
};

export default HowItWorks;
